module.exports = __webpack_public_path__ + "img/edge.17f937d7.png";